/* 3D-Tiefe für das drehende Header-Logo. Neu gefasst am 2026-09-12.

   Vorher lag hinter dem Logo eine zweite, um 180° gedrehte Kopie, damit der
   Schriftzug auch von hinten richtig herum stand. Eren wollte genau das
   Gegenteil: beim Drehen soll die echte Rückseite kommen, nicht nochmal die
   Vorderseite. Deshalb ist die Kopie raus – die Rückseite entsteht jetzt von
   allein, weil backface-visibility sichtbar bleibt.

   Stattdessen bekommt das Logo Tiefe: mehrere schwarze Kopien, in der
   Z-Achse gestaffelt. Von vorn sieht man nichts davon, beim Drehen wird
   daraus die Kante – wie bei einem Schild aus Metall.

   Heritage tauscht die Kopfzeile bei Seitenwechseln teils aus, deshalb wird
   beobachtet, ob ein neues Logo auftaucht. */
(function () {
  var SCHICHTEN = 12;     /* Kopien */
  var ABSTAND = 0.6;      /* px pro Kopie -> ~7 px "Materialstärke".
                             Mehr sah aus wie ein schwarzer Klotz, weil das
                             Logo in der Kopfzeile nur ~46 px hoch ist. */

  function tiefeGeben(container) {
    if (!container || container.querySelector('.lt-logo-layer')) return;
    var vorn = container.querySelector('img');
    if (!vorn) return;

    /* Alte Rückseite aus der Fassung von gestern entfernen. */
    var alt = container.querySelector('.lt-logo-back');
    if (alt) alt.remove();

    for (var i = 1; i <= SCHICHTEN; i++) {
      var schicht = vorn.cloneNode(true);
      schicht.className = 'lt-logo-layer';
      schicht.setAttribute('aria-hidden', 'true');
      schicht.removeAttribute('id');
      schicht.style.transform = 'translateZ(' + (-i * ABSTAND).toFixed(2) + 'px)';
      /* Die Kante bleibt schwarz, nur ganz leicht abgestuft, damit man
         die Tiefe sieht statt einer flachen Fläche. */
      schicht.style.opacity = (1 - i / (SCHICHTEN * 9)).toFixed(2);
      container.insertBefore(schicht, vorn);
    }
    container.classList.add('lt-logo-3d');
  }

  function alle() {
    document.querySelectorAll('.header-logo__image-container').forEach(tiefeGeben);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', alle);
  } else {
    alle();
  }

  new MutationObserver(alle).observe(document.documentElement, {
    childList: true,
    subtree: true
  });
})();
